<template>
  <div class="px-2 lg:px-2.5 xl:px-3 py-3 lg:py-3.5 xl:py-4 rounded-[10px] min-w-22 lg:min-w-28 xl:min-w-30 flex flex-col gap-y-2 bg-cw-green-alt font-bold tracking-tight">
    <div class="text-xs lg:text-sm xl:text-base text-[#3DC290]">Score</div>
    <div class="flex flex-col gap-y-1 lg:gap-y-0.5">
      <div class="flex text-xs lg:text-sm xl:text-base gap-x-2 justify-between text-[#669986]" v-for="(player, index) in sortedPlayers" :key="player.id">
        <p class="text-inherit" :class="{ 'text-white': player.id == userPlayerProfile!.id }">
          {{ player.id == userPlayerProfile!.id ? 'You' : player.username || (player.type === 'bot' ? 'Computer' : 'Player ' + (index + 1)) }}
        </p>
        <p class="text-inherit" :class="{ 'text-white': player.id == userPlayerProfile!.id }">{{ player.points }}</p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useGameStore } from '@/stores/game'
import type { PlayerT } from '@/types/User'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

const { allPlayers, userPlayerProfile } = storeToRefs(useGameStore())
const sortedPlayers = computed<PlayerT[]>(() => {
  if (!allPlayers.value || !userPlayerProfile.value) return []
  // Current player should always be first
  const currentPlayer = allPlayers.value.find(player => player.id === userPlayerProfile.value?.id)
  const otherPlayers = allPlayers.value.filter(player => player.id !== userPlayerProfile.value?.id) || []
  return [currentPlayer, ...otherPlayers] as PlayerT[]
})
</script>
